import React, { useState, useEffect } from "react";

import {
  Modal,
  ModalBody,
  Button,
  Input,
  ModalHeader,
  Label,
  ModalFooter,
  Alert,
  Collapse,
  Col,
  Row,
} from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import * as actionCreators from "../../../../modules/actions/index";
import Loading from "../../../../hoc/Loading/Loading";
import { AiFillCloseCircle } from "react-icons/ai";
import { MdFileUpload, MdOutlineMobileFriendly } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa6";
import Select from "react-select";
import { SURVEY_QUESTIONS } from "../../../../components/Survey/data";
import {
  BiMailSend,
  BiTrashAlt,
  BiX,
  BiCaretUp,
  BiCaretDown,
} from "react-icons/bi";
import { BsThreeDots } from "react-icons/bs";
import {
  isUrlValid,
  profilePicValidityCheck,
  trivvyFileTypeCheck,
  uploadPreview,
} from "../../../../utils/constants";
import { toastContainer } from "../../../../utils/toast";
import {
  minPlanLimitCheck,
  NUMBER_OF_ATTEMPTS_ALLOWED,
  SAMPLE_MESSAGING,
} from "../../data";
import ReactDatePicker from "react-datepicker";
import Toggle from "react-toggle";
import CheckBox from "rc-checkbox";
import ReactTooltip from "react-tooltip";
import OoPopover from "../../../../components/UI/Popover/OoPopover";
import ShareHandlingForMessagingTrivvys from "./ShareHandlingForMessagingTrivvys";
import Accordion from "../../../../components/AccordionCommon/Accordion";
import UpgradeTag from "../../../../components/UpgradeTag";
import BuildAithAiCard from "./BuildWithAicard";

const questionOptions = [
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
];

function CreateTriviaPopup({
  open,
  onClose,
  onAddSuccess,
  generateFromLibrary,
  preSelectedData,
  resourceId,
  incrementTrivCount,
  generateNewLibDocfromTools,
  user,
  onBack,
  uiType = "POPUP",
  autoSelectedTrivvyType = "CUSTOM",
  onTrivvyMultiGenerate,
  isMessaging,
  ...props
}) {
  const [formData, setFormData] = useState({
    name: "",
    fileUrl: "",
    uploadType: 1,
    uploadText: "",
    triviaType: 2,
    libraryId: null,
    questionsCount: null,
    trivvyParts: [],
    noOfTrivvys: 0,
  });

  const [isTitleManuallyTyped, setIsTitleManuallyTyped] = useState(false);
  const [errorsArr, setErrorsArr] = useState([]);
  const [currentFilters, setCurrentFilters] = useState("");
  const [scheduledDate, setScheduledDate] = useState(null);
  const [deletedIds, setDeletedIds] = useState([]);

  const [uploadedFile, setUploadedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [trivvyEndDate, setTrivvyEndDate] = useState(null);
  const [allowAttempts, setAllowAttempts] = useState(0);
  const [numberOfAttempts, setNumberOfAttempts] = useState(1);
  const [randomizeQuestions, setRandomizeQuestions] = useState(false);
  const [messagingSubject, setMessagingSubject] = useState("");
  const [messagingTitle, setMessagingTitle] = useState("");
  const [smsUsers, setSmsUsers] = useState([]);
  const [
    notifyAdminWhenUserRepliesToMessages,
    setNotifyAdminWhenUserRepliesToMessages,
  ] = useState(false);
  const [sampleMessagesCollapseOpen, setSampleMessagesCollapseOpen] = useState(
    false
  );

  const currentPaymentPlan =
    user.profile &&
    user.profile.organizationId &&
    user.profile.organizationId.trivvyPlanType;

  const isEnterprisePlan = minPlanLimitCheck(currentPaymentPlan, "004");

  const createSurvey = () => {
    const payload = {
      randomizeQuestions,
      organizationName: user.profile.organizationId.name,
      name: formData.name,
      questionsCount: formData.questionsCount,
      generateFromLibrary: generateFromLibrary ? true : false,
      triviaType: formData.triviaType,
      trivvyEndDate: trivvyEndDate,
      allowAttempts,
      numberOfAttempts: allowAttempts == 1 ? numberOfAttempts : null,
      isMessaging,
      numberOfAttempts: null,
      messagingSubject: messagingSubject,
      smsUsers: smsUsers,
      notifyAdminWhenUserRepliesToMessages,
    };

    const triviaForm = new FormData();
    triviaForm.append("payload", JSON.stringify(payload));

    if (formData.triviaType == 2) {
      setLoading(true);
      axios
        .post(url.createTrivia, triviaForm)
        .then(({ data }) => {
          onAddSuccess(data.data);
        })
        .catch((err) => {
          setLoading(false);
          console.log("errr", err);
        });
    }
  };

  const createAndSendSMSSurvey = () => {
    const users_share = smsUsers.map((itm) => {
      const user = itm;
      const mediums = [];

      if (user.mobileNumber) {
        mediums.push("SMS");
      }

      if (user) {
        return {
          createDate: new Date(),
          status: "ACTIVE",
          smsDate: new Date(),
          firstName: user.firstName,
          lastName: user.lastName,
          userId: user.value,
          date: itm.date ? itm.date : new Date(),
          genderPronoun: user.genderPronoun,
          profilePic: user.profilePic,
          email: user.email,
          mobileNumber: user.mobileNumber,
          shareMediums:
            itm.shareMediums && itm.shareMediums.length > mediums.length
              ? itm.shareMediums
              : mediums,
        };
      } else {
        return {
          userId: itm.value,
          firstName: itm.label,
          lastName: "",
          date: itm.date ? itm.date : new Date(),
        };
      }
    });

    const getNameFormatted = () => {
          const candidates = [
            formData.name,
            messagingTitle,
            messagingSubject ? (messagingSubject.length > 10 ? `${messagingSubject.slice(0, 10)}...` : messagingSubject) : null,
            "Text survey"
          ];
      return candidates.find(Boolean);
    };

    const payload = {
      notifyAdminWhenUserRepliesToMessages,
      isMessaging: true,
      organizationName: user.profile.organizationId.name,
      name: getNameFormatted(),
      questionsCount: 0,
      generateFromLibrary: false,
      triviaType: formData.triviaType,
      trivvyEndDate: trivvyEndDate,
      allowAttempts: 0,
      numberOfAttempts: numberOfAttempts,
      messagingSubject: messagingSubject,
      scheduledDate: scheduledDate,
      filters: currentFilters,
      deletedUserIds: deletedIds,
      skipUsers: true,
    };

    if (formData.triviaType == 2) {
      axios
        .post(url.createAndSendIsMessageTypeTrivvy, payload)
        .then(({ data }) => {
          toastContainer(`Messaging Trivvy Created Successfully`, "success");
          onAddSuccess(data.data);
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors.message
          ) {
            toastContainer(error.response.data.errors.message, "error");
          }
        });
    }
  };

  const isValidResponses = () => {
    let errors = [];
    let bool = true;
    if (isMessaging) {
      if (!messagingSubject) {
        errors.push("Please enter subject");
        bool = false;
      }
      // if (!smsUsers.length) {
      //   bool = false
      //   errors.push('Please add users')
      // }
    } else {
      if (!formData.name) {
        bool = false;
        errors.push("Please enter Name");
      }

      if (!formData.questionsCount) {
        bool = false;
        errors.push("Please enter no of questions");
      }
    }

    setErrorsArr(errors);

    return bool;
  };

  const getValueForAttemptDD = () => {
    if (allowAttempts == 0) {
      return "NO";
    } else if (allowAttempts == 2) {
      return "MANY";
    } else if (allowAttempts == 1) {
      return numberOfAttempts;
    }
  };

  const modalUi = () => {
    return (
      <div className="createTriviaPopupContainer">
        {/* Basic config UI */}
        <div className="createTriviaPopupContainerUi1">
          <div className="my-3">
            <Label> {isMessaging ? "Message title" : "Name*"}</Label>
            <Input
              onChange={(e) => {
                setFormData({ ...formData, name: e.target.value });
                setIsTitleManuallyTyped(e.target.value.length > 0);
              }}
              value={formData.name}
              placeholder="Please enter a name"
            />
          </div>

          {isMessaging && (
            <div className="my-3">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <span>Sample Messages</span>
                </div>

                <div>
                  {sampleMessagesCollapseOpen ? (
                    <BiCaretUp
                      onClick={() => {
                        setSampleMessagesCollapseOpen(false);
                      }}
                      style={{ cursor: "pointer" }}
                    />
                  ) : (
                    <BiCaretDown
                      onClick={() => {
                        setSampleMessagesCollapseOpen(true);
                      }}
                      style={{ cursor: "pointer" }}
                    />
                  )}
                </div>
              </div>

              <Collapse isOpen={sampleMessagesCollapseOpen}>
                <div className="bwai-txt-container">
                  <div className="mx-0 px-0 d-flex">
                    {" "}
                    {SAMPLE_MESSAGING.map((prompt, index) => (
                      <Col md={4} xs={12} key={index} className="mt-3">
                        <BuildAithAiCard
                          title={prompt.title}
                          description={prompt.description}
                          onSelect={() => {
                            setMessagingSubject(prompt.description);
                            setMessagingTitle(prompt.title);
                            if (!isTitleManuallyTyped) {
                              setFormData({ ...formData, name: prompt.title });
                            } 
                          }}
                          buttonText="Insert Text"
                        />
                      </Col>
                    ))}
                  </div>
                </div>
              </Collapse>
            </div>
          )}

          {isMessaging && (
            <div className="my-3">
              <Label>Message content*</Label>
              <span className="font-11px ml-2">
                {messagingSubject.length}/1500 (Message content)
              </span>
              <textarea
                value={messagingSubject}
                onChange={(e) => {
                  if (e.target.value.length <= 1500) {
                    setMessagingSubject(e.target.value);
                  }
                }}
                rows={6}
                className="w-100"
                placeholder="Write any type of communication you would like to share"
                maxLength={1500}
              />
            </div>
          )}

          {/* 
          {isMessaging && (
            <ShareHandlingForMessagingTrivvys
              setSmsUsers={setSmsUsers}
              user={user}
              currentFilters={currentFilters}
              setCurrentFilters={setCurrentFilters}
              setDeletedIds={setDeletedIds}
              deletedIds={deletedIds}
            />
          )} */}

          {isMessaging && (
            <div className="my-3">
              <Label className="mb-0">
                Notify me when users respond.
                {/* Notify me when users respond to text messages */}
              </Label>

              <CheckBox
                className="ml-2"
                checked={notifyAdminWhenUserRepliesToMessages}
                onChange={(e) => {
                  setNotifyAdminWhenUserRepliesToMessages(e.target.checked);
                }}
              />
            </div>
          )}

          {!isMessaging ? (
            <div>
              <div className="my-3">
                <Alert color="info">
                  Tip: Keep surveys to 5 questions or fewer for best results.
                  You can always add more in the Edit phase.
                </Alert>
                <Label>Number of Questions*</Label>
                <Select
                  value={formData.questionsCount}
                  onChange={(e) => {
                    setFormData({ ...formData, questionsCount: e.value });
                  }}
                  options={questionOptions}
                  placeholder="Select number of questions..."
                />
              </div>

              {/* Other options ui */}
              <div className="createTriviaPopupContainerUi3">
                <div className="my-3">
                  <Label>Select End Date</Label>
                  <div style={{ maxHeight: "400px" }}>
                    <ReactDatePicker
                      id="actionDueDate"
                      minDate={moment().toDate()}
                      placeholderText="Enter date: MM/DD/YYYY"
                      className="form-control filter-action-date-input"
                      selected={trivvyEndDate}
                      onChange={(v) => {
                        if (v && v != null && v != undefined) {
                          const date = moment(v)
                            .endOf("day")
                            .local();
                          setTrivvyEndDate(date);
                        }
                      }}
                      showYearDropdown
                    />
                  </div>
                </div>

                <div className="my-3">
                  <Label>
                    Allow Retakes{" "}
                    <OoPopover
                      target="allow_retake"
                      headerText={"Allow Retakes"}
                      bodyText={
                        "Allow users to take/attempt Trivvy multiple times."
                      }
                    />
                  </Label>
                  <Select
                    options={NUMBER_OF_ATTEMPTS_ALLOWED}
                    onChange={(e) => {
                      if (typeof e.value == "number") {
                        setAllowAttempts(1);
                        setNumberOfAttempts(e.value);
                      } else {
                        if (e.value == "NO") {
                          setAllowAttempts(0);
                          setNumberOfAttempts(null);
                        } else if (e.value == "MANY") {
                          setAllowAttempts(2);
                          setNumberOfAttempts(null);
                        }
                      }

                      setNumberOfAttempts(e.value);
                    }}
                    value={getValueForAttemptDD()}
                    placeholder="Select No Of Attempts"
                  />
                </div>

                <div className="my-3">
                  <Label>
                    Allow Randomize Questions{" "}
                    <OoPopover
                      target="allow_randomize"
                      headerText={"Allow Randomize Questions"}
                      bodyText={
                        "Enabling this option will change the questions order everytime users take Trivvy."
                      }
                    />
                  </Label>
                  <Toggle
                    className="ml-3"
                    checked={randomizeQuestions}
                    onChange={(e) => {
                      setRandomizeQuestions(e.target.checked);
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div className="my-3">
                {isEnterprisePlan ? (
                  <div className="d-flex justify-content-between align-items-center">
                    <div>Scheduled Date</div>
                    <div>
                      <ReactDatePicker
                        dateFormat="MM/DD/YYYY 𝖺𝗍 h:mm a"
                        id="actionDueDate"
                        placeholderText="Enter date: MM/DD/YYYY"
                        className="form-control filter-action-date-input"
                        minDate={new Date()}
                        minTime={
                          scheduledDate
                            ? moment().isSame(moment(scheduledDate), "day")
                              ? moment()
                              : moment().startOf("day")
                            : moment()
                        }
                        maxTime={moment().endOf("day")}
                        selected={
                          typeof scheduledDate == "string"
                            ? moment(scheduledDate)
                            : scheduledDate
                        }
                        onChange={(v) => {
                          if (v) {
                            const date = moment(v);

                            if (
                              moment()
                                .startOf("day")
                                .isSame(date, "hour")
                            ) {
                              // Today @ midnight selected: bump to the next full hour (TBV-624: 00 min, 00 sec)
                              setScheduledDate(
                                moment()
                                  .add(1, "hour")
                                  .startOf("hour")
                              );
                            } else {
                              if (
                                moment(date)
                                  .startOf("day")
                                  .isSame(date, "hour")
                              ) {
                                // Future day @ midnight selected: default to 09:00:00
                                setScheduledDate(date.add(9, "hours").startOf("hour"));
                              } else {
                                // Normalize to top of the hour (00 min, 00 sec) per TBV-624 hot fix
                                setScheduledDate(date.startOf("hour"));
                              }
                            }
                          } else {
                            setScheduledDate(null);
                          }
                        }}
                        showYearDropdown
                        showTimeSelect
                        timeFormat="h:mm a"
                        timeIntervals={60}
                      />
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <p
                      style={{
                        color: isEnterprisePlan ? "inherit" : "#6B7280",
                      }}
                    >
                      {" "}
                      Auto schedule your trivvys <UpgradeTag text="Upgrade" />
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  console.log("898989898");

  return (
    <div>
      {uiType == "POPUP" ? (
        <Modal isOpen={open} className="create-trivia-modal-component">
          <ModalHeader
            className="trivia_modal_header_bg"
            close={
              <BiX
                className="cursor-pointer"
                color="gray"
                size={30}
                onClick={() => onClose()}
              />
            }
          >
            Create New Trivvy
          </ModalHeader>
          <ModalBody
            className={`px-5 pt-2 pb-5 ${
              loading ? "wrapped-component-on-loading" : ""
            }`}
          >
            {modalUi()}

            {errorsArr && errorsArr.length ? (
              <Alert color="danger" className="my-2">
                <ul>
                  {errorsArr.map((x) => (
                    <li>{x}</li>
                  ))}
                </ul>
              </Alert>
            ) : (
              ""
            )}
          </ModalBody>

          <ModalFooter>
            {!loading ? (
              <Button
                color="success"
                className="mr-4 btn-success"
                onClick={() => {
                  if (isValidResponses()) {
                    setErrorsArr([]);
                    if (isMessaging) {
                      createSurvey();
                    } else {
                      createAndSendSMSSurvey();
                    }
                  }
                }}
              >
                {!isMessaging ? "Generate" : "Create Message"}{" "}
                <FaArrowRight className="ml-2" />{" "}
              </Button>
            ) : (
              <span> {isMessaging ? "Generating" : "Creating"}...</span>
            )}
          </ModalFooter>
        </Modal>
      ) : (
        <div>
          {modalUi()}

          {errorsArr && errorsArr.length ? (
            <Alert color="danger" className="my-2">
              <ul>
                {errorsArr.map((x) => (
                  <li>{x}</li>
                ))}
              </ul>
            </Alert>
          ) : (
            ""
          )}

          <ModalFooter className="justify-content-between">
            {onBack ? <Button onClick={onBack}>Back</Button> : ""}
            {!loading ? (
              <Button
                color="success"
                className="btn-success"
                onClick={() => {
                  if (isValidResponses()) {
                    setErrorsArr([]);
                    if (isMessaging) {
                      console.log("hello here now 3");
                      createAndSendSMSSurvey();
                    } else {
                      console.log("hello here now 2");
                      createSurvey();
                    }
                  }
                }}
              >
                {!isMessaging ? "Generate" : "Create"}{" "}
                <FaArrowRight className="ml-2" />{" "}
              </Button>
            ) : (
              <span>{!isMessaging ? "Generating" : "Creating"}...</span>
            )}
          </ModalFooter>
        </div>
      )}
    </div>
  );
}

export default Loading(CreateTriviaPopup, axios);
